import { EntityId } from 'entities-next/common'
import { DASHBOARD_PATH } from 'scenes/Dashboard/Dashboard.routes'

export const CORPORATE_MANAGER_PATH = `${DASHBOARD_PATH}/corporate-manager`
export const CORPORATE_MANAGER_LIST_PATH = CORPORATE_MANAGER_PATH
export const CORPORATE_MANAGER_DETAILS_PATH = `${CORPORATE_MANAGER_LIST_PATH}/:corporateId`
export const CORPORATE_MANAGER_NEW_USER = `${CORPORATE_MANAGER_LIST_PATH}/new`

export function getCorporateDetailsPath(corporateId: EntityId) {
  return `${CORPORATE_MANAGER_LIST_PATH}/${corporateId}`
}
